/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Back Icon component.
 */
export const MaterialBackIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_19480)'>
        <path fillRule='evenodd' clipRule='evenodd' d='M16.8667 5.86667L15 4L7 12L15 20L16.8667 18.1333L10.7333 12L16.8667 5.86667Z' fill={iconColor} />
      </g>
      <defs>
        <clipPath id='clip0_14304_19480'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MaterialBackIcon;
